import { userListUsersTableStyles } from "@insite/content-library/Widgets/UserList/UserListUsersTable";
import { css } from "styled-components";

Object.assign(userListUsersTableStyles, {
    noResultsText: {
        variant: "h3",
    },
});
